


































import { Prop, Component, Vue } from "vue-property-decorator";
import HalfNumbersConverter from "@/helpers/HalfNumbersConverter";

const reTel = /^[0-9]{1,4}-[0-9]{1,4}-[0-9]{1,4}$/;

@Component({
  props: {
    required: {
      type: Boolean,
      default: false
    }
  }
})
export default class InputPhoneNumber extends Vue {
  @Prop({ default: "" }) id!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) value!: string;

  private converter = new HalfNumbersConverter();

  get parts(): [string, string, string] {
    const [p1, p2, p3] = [...this.value.split("-"), "", ""].slice(0, 3);
    return [p1, p2, p3];
  }

  get part1(): string {
    return this.parts[0];
  }

  set part1(p: string) {
    this.input(this.converter.convert(p), this.part2, this.part3);
  }

  get part2(): string {
    return this.parts[1];
  }

  set part2(p: string) {
    this.input(this.part1, this.converter.convert(p), this.part3);
  }

  get part3(): string {
    return this.parts[2];
  }

  set part3(p: string) {
    this.input(this.part1, this.part2, this.converter.convert(p));
  }

  mounted() {
    this.validate();
  }

  updated() {
    this.validate();
  }

  input(p1: string, p2: string, p3: string) {
    const value = p1 || p2 || p3 ? `${p1}-${p2}-${p3}` : "";
    this.$emit("input", value);
    // 同じ数字が全角で入ってきた際に更新されないので強制的に更新する
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  }

  validate() {
    const i = this.$refs.main as HTMLInputElement;
    if (this.value && !reTel.test(this.value)) {
      i.setCustomValidity("間違った形式です。例: 000-000-0000");
    } else {
      i.setCustomValidity("");
    }
  }
}
